<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
  <p>
    <mat-form-field appearance="outline">
        <mat-label>Search for a batch</mat-label>
        <input required type="text" placeholder="Search for batches" aria-label="Search for a batch" matInput [formControl]="batchNumber" [matAutocomplete]="auto">
        <mat-autocomplete data-testid="add-medicine-autocompletion-list" (optionSelected)="batchSelected($event)" autoActiveFirstOption #auto="matAutocomplete">
            <mat-option *ngFor="let batch of batches" [value]="batch">
                {{batch.batch_number}} - {{batch.medicine_dosage_type.medicine.name}}
            </mat-option>
        </mat-autocomplete>
        <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button [disabled]="!selectedBatch" mat-raised-button (click)="linkToBatch()" color="primary" cdkFocusInitial>Link</button>
</div>
